import { ReactNode } from 'react';
import { ChevronLeft } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { Drawer, IconButton, useMediaQuery } from '@mui/material';

export type DrawerType = 'credit' | 'tag' | 'match';
export type Method = 'manual' | 'copy';
interface Props {
  children: ReactNode;
  drawer?: DrawerType;
  count: number;
  method?: Method;
  onChangeMethod: (method?: Method) => void;
  onCancel: () => void;
  left?: number;
}

export const AddDrawer = ({
  children,
  drawer,
  count,
  method,
  onChangeMethod,
  onCancel,
  left = -24,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const sx = isMobile ? {
    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '100%' },
  } : {
    width: '35%',
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: '35%',
      boxSizing: 'border-box',
      top: 0,
      left,
      zIndex: 50,
      position: 'absolute',
      borderTopRightRadius: '5px',
    },
  };

  const header = (
    <div className=" bg-alpineTeal text-white font-bold flex justify-between items-center pl-6">
      <div>
        Add
        {' '}
        {drawer}
        {' '}
        to
        {' '}
        {count}
        {' '}
        selected
      </div>
      <IconButton onClick={onCancel}>
        <ChevronLeft className="text-white" fontSize="large" />
      </IconButton>
    </div>
  );

  return (
    <Drawer
      sx={sx}
      variant="persistent"
      anchor="left"
      open={drawer !== undefined}
      ModalProps={{
        keepMounted: isMobile, // Better open performance on mobile.
      }}
    >
      {header}
      {!method && (
        <div className="px-6">
          <div className="font-bold text-xl my-4">
            Select a
            {' '}
            {drawer}
            ing method
          </div>
          <div className="flex flex-wrap gap-4 mb-4">
            <button
              type="button"
              className="btn-primary"
              onClick={() => onChangeMethod('manual')}
            >
              Manually add
              {' '}
              {drawer}
              s
            </button>
            <button
              type="button"
              className="btn-primary-outlined"
              onClick={() => onChangeMethod('copy')}
            >
              Copy
              {' '}
              {drawer}
              s
              {' '}
              from a post
            </button>
          </div>
        </div>
      )}
      {children}
    </Drawer>
  );
};
